<template>
  <div class="container">
    <div class="searchBox">
       <div class="left">
          <el-form :inline="true">
            <el-form-item>
                <el-input placeholder="请输入销售商/供应商名字" v-model="formObj.fuzzyQuery" clearable></el-input>
            </el-form-item>
              <el-form-item>
                  <el-button icon="el-icon-search" type="primary" @click="fuzzySearchClick">查询</el-button>
              </el-form-item>
          </el-form>
      </div>

      <div class="right">
        <el-button type="primary" @click="toAdd" v-if="function_addAndEditUser">去添加客户</el-button>
        <!-- <el-button>下载客户列表</el-button> -->
      </div>
    </div>
    <div class="tableBox">
      <el-table v-loading="isLoading" :data="tableData">
        <!--     <el-table-column type="selection" width="55">
                </el-table-column> -->
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">{{ total-((searchObj.page-1)*searchObj.num+ scope.$index) }}</template>
        </el-table-column>
        <!--  <el-table-column label="用户公司">
                    <template slot-scope="scope">{{ scope.row.user_organization_name }}</template>
                </el-table-column>
                <el-table-column label="用户姓名">
                    <template slot-scope="scope">{{ scope.row.user_individual_name }}</template>
                </el-table-column> -->
        <el-table-column label="用户名/公司名" min-width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.user_individual_name">
              <span class="nameSpan"> {{ scope.row.user_individual_name }} </span>
              <el-tag type="danger" size="mini">个人</el-tag>
            </div>
            <div v-if="scope.row.user_organization_name">
              <span class="nameSpan">{{ scope.row.user_organization_name }}</span>
              <el-tag type="success" size="mini">公司</el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="用户ID" width="50">
            <template slot-scope="scope">{{ scope.row.user_id }}</template>
        </el-table-column>
        <el-table-column label="用户手机" width="120">
          <template slot-scope="scope">{{ scope.row.user_cellphone }}</template>
        </el-table-column>

        <el-table-column label="身份" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.user_initial_type==2" >销售商</span>
            <span v-if="scope.row.user_initial_type==1" class="blue">供应商</span>

          </template>
        </el-table-column>

        <el-table-column label="品牌" min-width="170">
          <template slot-scope="scope">
            <el-tag type="danger" v-for="(list,index) in scope.row.brandArr" size="mini" v-if="index<3" style="margin-bottom: 5px;margin-right: 5px;">
              {{list}}</el-tag>

            <el-popover placement="top-start" title="所有品牌" width="200" trigger="hover">
              <p>
                <el-tag type="danger" v-for="(list,index) in scope.row.brandArr" size="mini" style="margin-bottom: 5px;margin-right: 5px;">{{list}}</el-tag>
              </p>
              <span slot="reference" v-show="scope.row.brandArr.length>3" style="font-size: 12px;color:#aaa">更多..</span>
            </el-popover>


          </template>
        </el-table-column>

        <el-table-column label="联系人">
          <template slot-scope="scope">{{ scope.row.user_contact_person }}</template>
        </el-table-column>
        <el-table-column label="联系手机">
          <template slot-scope="scope">{{ scope.row.user_contact_cellphone }}</template>
        </el-table-column>
        <el-table-column label="地址">
          <template slot-scope="scope">{{ scope.row.company_province }} {{ scope.row.company_city }}</template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
           <span :class="tagWord[scope.row.user_state]">{{ userState[scope.row.user_state] }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="头像">
                    <template slot-scope="scope">
                      <img :src="scope.row.avatar" alt="" class="avatarImg">
                    </template>
                </el-table-column> -->

        <el-table-column label="操作" width="270px" fixed="right">
          <template slot-scope="scope">
            <div class="controlBox">
              <el-tag class="tagBtn" size="mini" type="primary" @click="toDetail(scope.row)" v-if="function_viewUserDetail">详情</el-tag>
              <el-switch
                v-model="scope.row.isSendMsg" @change="changeIsSendMsg(scope.row)"
                active-color="#409EFF"
                inactive-color="#ccc" v-show="function_otherUserControl">
              </el-switch>
              <span v-if="scope.row.isSendMsg" style="color:#409EFF;font-size: 12px;">发短信</span>
              <span v-if="!scope.row.isSendMsg" style="color:#ccc;font-size: 12px;">不提醒</span>
              <el-tag  class="tagBtn" size="mini"  type="primary" @click="openAddGoods(scope.row)"  v-show="function_otherUserControl">批量传商品</el-tag>
              <el-tag  class="tagBtn" size="mini"  type="primary" @click="downloadGoods(scope.row)"  >导出商品</el-tag>

              <el-tag class="tagBtn" size="small" v-if="scope.row.user_state=='p'"  type="danger" @click="toAuth(scope.row)"  v-show="function_otherUserControl">点击审核</el-tag>
              <!-- <el-tag class="tagBtn" size="small" type="primary" @click="toEdit(scope.row)">修改</el-tag> -->

              <!-- <el-tag  class="tagBtn" size="small"  type="primary" @click="openAddBrandModal(scope.row)">新增品牌</el-tag> -->



            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pageBox">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="searchObj.page"
        :page-size.sync="searchObj.num" layout="total, sizes, prev, pager, next, jumper" :total="total" background>
      </el-pagination>
    </div>

    <addbrand :isShow="isShowAddBrandModal" :info="currentAddModalObj" @close="closeAddModal" @closeAndSuccess="closeAddModalAndSucess"></addbrand>
    <userauth v-show="isShowAuthModal" :info="currentAuthModalObj" @close="closeAuthModal" @success="closeAuthModalAndSucess"></userauth>
    <uploadgroup v-show="isShowUploadGroupModal" :info="currentUploadModal" @close="closeUploadModal" @success="closeUploadModalAndSucess"></uploadgroup>
   <!-- <el-dialog      title="商品批量上传"      :visible.sync="isShowUploadGroupModal"      width="40%"
     v-loading="importLoading" element-loading-text="批量上传处理中"    element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="uploadContent">
        <div class="oneLine">商家名称： <span class="darkBlue">{{currentUploadModal.user_organization_name||currentUploadModal.user_individual_name}}</span> </div>
        <div class="oneLine">商家手机号：<span class="darkBlue">{{currentUploadModal.user_cellphone}}</span></div>
        <div class="oneLine">商家ID: <span class="blue"></span>{{currentUploadModal.user_id}}</div>
        <div class="imgPrevArea">
          <div class="oneFileBLock" v-for="(list,index) in fileData">
            <span style="margin-right: 20px;">{{list.name}}</span>
            <el-tag type="danger" size="mini" @click="deleteFile(index)" class="deleteIcon">删除</el-tag>
          </div>
        </div>
        <el-upload :show-file-list="false" ref="upload"  list-type="text"  accept=".xlsx,.xls"   action="" :on-change="changeHandler" :limit="1"     :auto-upload="false">
          <el-button slot="trigger"  type="primary" v-show="fileData.length<1">点击选取文件</el-button>
          <el-button  type="danger"  v-show="fileData.length>=1" @click="submitUpload">确定上传该文件</el-button>
        </el-upload>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
  import {
    json,
    wordData
  } from '@/common/common.js'
  import {
    ajaxPost,ajaxLogin
  } from '@/common/request.js'
  import {
    ajaxImport
  } from '@/common/request_import.js'
  import {
    utils
  } from '@/common/common.js'
  import {
    getSignStr
  } from '@/common/tool.js'
  import { saveAs } from 'file-saver'
  import moment from 'moment'

  import addbrand from '@/components/addBrand.vue'
  import userauth from '@/components/userauth.vue'
  import uploadgroup from '@/components/uploadgroup.vue'

  export default {
    name: 'adminIndex',
    data() {
      return {
        importLoading:false,
        isShowUploadGroupModal:false,
        isShowAuthModal:false,
        downloadLoading:false,
        currentAuthModalObj:{},
        currentUploadModal:{},
        // fileList: [],
        // fileData:[],
        isShowAddBrandModal: false,
        currentAddModalObj: {},
        lastPage: '',
        newLinkParamObj: {},
        isShowAddOrderModal: false,
        isLoading: false,
        msg: 'Welcome to Your Vue.js App',
        formObj: {
          fuzzyQuery: '',
        },
        searchObj: {
          page: 1,
          num: 10,
        },
        //表格
        tableData: [],
        multipleSelection: [],
        //分页
        total: 0,
        currentAuthList: "12312312312312",
        isShowModal: false,
        tagWord: {
          y:'green',
          n:'grey',
          p:'red',
        },
        userState:{
          y:'通过',
          n:'被拒绝',
          p:'待审核',
        }

      }
    },
    computed: {
      function_viewUserDetail() {
        return utils.getCurrentFunction().indexOf("viewUserDetail")>-1
      },
      function_addAndEditUser() {
        return utils.getCurrentFunction().indexOf("addAndEditUser")>-1
      },
      function_otherUserControl() {
        return utils.getCurrentFunction().indexOf("otherUserControl")>-1
      },
      userTypeOptions() {
        return wordData.user_type
      },
      authResultOptions() {
        return wordData.auth_result
      },
      adminId() {
          return utils.getAdminId()
      },
      token(){
        return utils.getToken()
      },
      currentPageId() { //当前页面id
        let currentPath = this.$route.path
        let result = utils.getCurrentPageId(currentPath)
        return result
      },

    },
    watch: {
        $route: {
            handler: function(route) {
                this.searchObj.num = Number(this.$route.query.size)
                ? Number(this.$route.query.size)
                : 10;
                this.searchObj.page = Number(this.$route.query.page)
                ? Number(this.$route.query.page)
                : 1;
                this.formObj.fuzzyQuery = this.$route.query.search || "";
                this.getTableLists();
            },
            immediate: true
        }
    },
    components: {
      addbrand,userauth,uploadgroup
    },
    methods: {
      changeIsSendMsg(list){
        console.log(list)
        let _this = this
        let state=''
        if(list.isSendMsg){
          state='on'
        }else {
          state='off'
        }
        let arg = {
          userId: list.user_id,
          userSms:state
        }
        console.log(arg)
        ajaxPost('/admin/updateDwUserSms', arg).then(function(res) {
          console.log(res)
          if (res.errorCode == 200) {

          } else {
            _this.$message({
              message: res.errorMsg,
              type: 'warning',
              duration: 1500
            });
          }
          _this.getTableLists();
        })
      },
      downloadGoods(list){
        let _this=this

        console.log(list)
        let userName=list.user_organization_name||list.user_individual_name
        if(_this.isLoading){
          _this.$message({
            message: "商品正在下载中，请耐心等待", //接口返回一个页面
            type: 'warning',
            duration: 1500
          });
          return false
        }
        let tokenArg={
          token:this.token,
          adminId:this.adminId,
          userId:list.user_id,
        }
        ajaxLogin('/admin/user/getTokenByAdmin', tokenArg).then(function(res) {
          console.log(res)
          if (res.errorCode == 200) {
            let userId= tokenArg.userId
            let token= res.data.token_info
            let image_type="12102"//12101为原图，12102为大图，12104为缩略图
            let item_state=""   //商品状态，0为无效（删除），1为有效（上架），2为有效但不展示（下架），留空为全量导出

            var signArg={
              user_id: userId,
              user_token: token,
              image_type:image_type,
              item_state:item_state,
            }
            var signStr=getSignStr(signArg)
            var arg = {
              user_id: userId,
              user_token: token,
              image_type:image_type,
              item_state:item_state,
              sign:signStr
            };
            var url = '/digital_warehouse_php/?s=item&op=export'
            _this.isLoading=true
            ajaxImport(url, arg).then(function(res) {
              console.log(res)
              _this.isLoading=false
              if(res.error_code=='0'){
                _this.$message({
                  message: "下载商品成功", //接口返回一个页面
                  type: 'success',
                  duration: 2000
                });
                saveAs(res.data.file, `zciiss数字云仓商品_${userName}_${moment().format("YYYY年MM月DD日HH时mm分")}`);
                // window.location.href=res.data.file
              }else{
                _this.$message({
                  message: res.error_msg||"请求报错", //接口返回一个页面
                  type: 'error',
                  duration: 1500
                });
              }
            }).catch(function(res){
              _this.isLoading=false
            })



          } else {
          }
        })
      },
      toAuth(list){
          this.isShowAuthModal=true
          this.currentAuthModalObj=list
      },
      // // 批量上传
      // submitUpload() {
      //   console.log(this.fileData)
      //   let _this = this
      //   if(!this.fileData||this.fileData.length==0){
      //     alert("没有选取文件")
      //     return false
      //   }
      //   var fileObj=this.fileData[0]
      //   console.log(fileObj)
      //   if (typeof (fileObj) == "undefined" || fileObj.size <= 0) {
      //        return;
      //   }
      //   let number=25
      //   let sizeNumber=number*1024*1024
      //   if(fileObj.size>sizeNumber){
      //     _this.$message({
      //       message: "文件大小不能超过"+number+"M", //接口返回一个页面
      //       type: 'warning',
      //       duration: 1500
      //     });
      //     return;
      //   }
      //   // 图片预览
      //   // var fileReader = new FileReader();
      //   // fileReader.readAsDataURL(fileObj);
      //   // fileReader.onload = function () {
      //   //   $("#imgPrev").attr('src', this.result);
      //   // };
      //   let tokenArg={
      //     token:this.token,
      //     adminId:this.adminId,
      //     userId:this.currentUploadModal.user_id,
      //   }
      //   ajaxLogin('/admin/user/getTokenByAdmin', tokenArg).then(function(res) {
      //     console.log(res)
      //     if (res.errorCode == 200) {
      //       var userid = tokenArg.userId
      //       var token = res.data.token_info

      //       var formFile = new FormData();

      //       var signArg={
      //         user_id: userid,
      //         user_token: token,
      //         // files:fileObj
      //       }
      //       var signStr=getSignStr(signArg)
      //       formFile.append("upload_file", fileObj.raw); //加入文件对象
      //       formFile.append("user_id", userid);
      //       formFile.append("user_token", token); //加入文件对象
      //       formFile.append("sign", signStr); //加入文件对象
      //       var arg = formFile;
      //       console.log("转换之后的参数", formFile)
      //       var url = '/digital_warehouse_php/?s=item&op=import'
      //       _this.importLoading=true
      //       ajaxImport(url, arg).then(function(res) {
      //         console.log(res)
      //         _this.importLoading=false
      //         if(res.error_code=='0'){
      //           _this.$message({
      //             message: "批量上传成功", //接口返回一个页面
      //             type: 'success',
      //             duration: 1500
      //           });
      //           _this.isShowUploadGroupModal=false

      //         }else{
      //           _this.$message({
      //             message: res.error_msg||"请求报错", //接口返回一个页面
      //             type: 'error',
      //             duration: 1500
      //           });
      //         }
      //       }).catch(function(res){
      //         _this.importLoading=false
      //       })



      //     } else {
      //     }
      //   })


      // },
      updateRouter() {
          this.$router
              .push(
              "/user/list?search=" +
                  this.formObj.fuzzyQuery +
                  "&page=" +
                  this.searchObj.page +
                  "&size=" +
                  this.searchObj.num

              )
      },
      // changeHandler(file, fileList){
      //   console.log(file, fileList);
      //   this.fileData=fileList
      // },
      // deleteFile(index){
      //   this.$confirm('确认删除文件重新选取吗？', '提示', {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning'
      //   }).then(() => {
      //     this.fileData.splice(index)
      //   }).catch(() => {
      //   });

      // },


      openAddGoods(list) {
        console.log(list)
        this.isShowUploadGroupModal=true
        this.currentUploadModal=list

      },
      closeAddModal() {
        console.log("关闭方法被触发")
        this.isShowAddBrandModal = false
      },
      closeAddModalAndSucess() {
        console.log("关闭并且成功方法被触发")
        this.isShowAddBrandModal = false
        this.currentAddModalObj = {}
        this.getTableLists()
      },
      closeAuthModal() {
        console.log("审核关闭方法被触发")
        this.isShowAuthModal = false
      },
      closeAuthModalAndSucess() {
        console.log("审核关闭并且成功方法被触发")
        this.isShowAuthModal = false
        this.currentAuthModalObj = {}
        this.getTableLists()
      },
      closeUploadModal(){
        console.log("批量上传关闭方法被触发")
        this.isShowUploadGroupModal = false
      },
      closeUploadModalAndSucess(){
        console.log("批量上传关闭并且成功方法被触发")
        this.isShowUploadGroupModal = false
        this.currentUploadModal = {}
        this.getTableLists()
      },
      openAddBrandModal(list) {
        console.log(list)
        let _this = this
        this.isShowAddBrandModal = true
        let arg = {
          userId: list.user_id
        }
        let brandArr = []
        ajaxPost('/commodity/brandListByUser', arg).then(function(res) {
          console.log(res)
          if (res.errorCode == 200) {
            res.data.map(function(item, index) {
              brandArr.push(item.item_display_name)
            })

          } else {
            brandArr = []
          }
          _this.currentAddModalObj = {
            userId: list.user_id,
            name: list.user_individual_name || list.user_organization_name,
            brandArr: brandArr
          }
        })


      },
      toEdit(list) {
        this.$router.push('/user/edit?userId=' + list.user_id);
      },
      toDetail(list) {
        this.$router.push('/user/detail?userId=' + list.user_id);
      },
      getParams() {
        this.lastPage = this.$route.query.from
      },
      back() {
        this.$router.back()
      },
      closeModal_Upload() {
        console.log('list.vue 的关闭事件')
        this.isShowModal = false
      },
      openAuth(list) {
        this.currentAuthList = list
        this.isShowModal = true
      },

      openNewLinkModal(list) {
        console.log(list)
        this.isShowAddOrderModal = true
        this.newLinkParamObj = list
      },
      toAdd() {
        this.$router.push({
          name: 'userAdd',
        })
      },
      // toDetail(list) {
      //   let _this = this
      //   let userId = list.user_id
      //   if (!userId) {
      //     _this.$message({
      //       message: "该条数据有误，没有userId", //接口返回一个页面
      //       type: 'error',
      //       duration: 1500
      //     });
      //   } else {
      //     utils.setSearchObjToSession(_this.searchObj)
      //     this.$router.push({
      //       name: 'customerDetail',
      //       params: {
      //         userId: userId,
      //         href: 'customer'
      //       }
      //     })
      //   }
      // },
      fuzzySearchClick() {
          this.searchObj.page = 1;
          this.updateRouter();
      },
      getTableLists() {
        let _this = this
        this.isLoading = true
        let arg={
          fuzzyQuery: this.formObj.fuzzyQuery,
          page: this.searchObj.page,
          num: this.searchObj.num,
        }
        ajaxPost('/admin/userList',arg).then(function(res) {
          _this.tableData = []
          _this.isLoading = false
          if (res.data && res.data.userList) {
            _this.total = parseInt(res.data.userCount)
            res.data.userList.forEach(function(item, index) {
              let buffer = item
              buffer.isSendMsg=item.user_sms=='on'?true:false
              buffer.brandArr = []
              if (item.brandInfoLIst) {
                buffer.brandArr = item.brandInfoLIst.map(function(t, i) {
                  return t.item_display_name
                })
              }

              _this.tableData.push(buffer)

            })

          }
        }, function(res) {
          _this.isLoading = false
        })
      },
      handleSizeChange(size) { //分页：每页n条
          this.searchObj.num = size
          this.searchObj.page = 1
          this.updateRouter()
      },
      handleCurrentChange(page) { //分页：改变第n页
          this.searchObj.page = page
          this.updateRouter()
      },


      handleSelectionChange(val) { //表格多选框
        this.multipleSelection = val;
        console.log(this.multipleSelection)
      }
    },
    created() {
      console.log("执行created")
      //获取session里存储的搜索条件，并赋值给当前表单
      this.getParams()

      let _this = this
      let sessionSearch = utils.getSearchObjFromSession()
      if (sessionSearch) {
        console.log("session里存储了搜索条件")
        _this.searchObj = sessionSearch
        this.formObj.fuzzyQuery = _this.searchObj.phone
        this.formObj.userType = _this.searchObj.userType
        this.formObj.authResult = _this.searchObj.authResult
      } else if (_this.lastPage == 'home') {
        _this.searchObj.authResult = 'p'
        this.formObj.authResult = _this.searchObj.authResult
      } else {
        console.log("session里没有搜索条件，也不是首页直接跳转")
      }
      console.log(_this.searchObj, 'mounted里的搜索条件1111')
      this.getTableLists()

    },
    mounted() {
      console.log("执行mounted")
    }
  }
</script>

<style scoped lang="scss">
  * {
    // outline: 1px solid blue;
  }

  .container {}

  .avatarImg {
    width: 60px;
    height: 60px;
  }

  .searchBox {
    padding: 0.25rem 0.25rem 0;

    .left {
      float: left;
    }

    .right {
      float: right;
    }
  }

  .searchBox:after {
    content: "";
    display: block;
    clear: both;
  }

  .tableBox {
    padding: 0.25rem;
  }

  .nameSpan {
    display: inline-block;
    min-width: 150px;
  }
  .btn{cursor: pointer; }
  .btn:hover{opacity:0.8;}

  .controlBox{
    .tagBtn{cursor: pointer;margin-bottom:5px;}
    .tagBtn:hover{opacity: 1;color:#fff;}
    .el-tag.el-tag--success:hover{background: #79d44c;}
    .el-tag.el-tag--warning:hover{background: #e6a23c;}
    .el-tag.el-tag--info:hover{background: #909399;}
    .el-tag.el-tag--danger:hover{background: red;}
    .el-tag.el-tag--primary:hover{background: #66B1FF;}
  }



</style>



// WEBPACK FOOTER //
// src/pages/user/list.vue